"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NoOptionMessage;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _MenuItem = _interopRequireDefault(require("../../MenuItem"));
var _Typography = _interopRequireDefault(require("../../Typography"));
/* eslint react/prop-types: 0 */

function NoOptionMessage(props) {
  var innerProps = props.innerProps,
    children = props.children,
    selectProps = props.selectProps;
  return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], (0, _extends2["default"])({
    className: selectProps.classes.noOptionMessage,
    component: "div",
    "data-metrics": selectProps.dataMetrics.noOptionsMessage,
    disabled: true
  }, innerProps), /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    component: "span",
    noWrap: true
  }, innerProps, {
    variant: "body1"
  }), children));
}